import React from 'react';

const ReadOnlyFormContext = React.createContext();

export default ReadOnlyFormContext;
